import { z } from 'zod';

import type { PK } from './database.schema';
import { baseDatabaseSchema, userSchema } from './database.schema';

export const COMMENT_QUOTE_MAX_LENGTH = 2000;

// Offsets index the block's anchor text (helpers/comments/anchor-text.ts), never the HTML string.
export const commentAnchorSchema = z
  .object({
    start: z.number().int().min(0),
    end: z.number().int().min(1),
    text: z.string().min(1),
    quote: z.string().min(1).max(COMMENT_QUOTE_MAX_LENGTH),
  })
  .strict()
  .refine((anchor) => anchor.end > anchor.start, { message: 'anchor end must be greater than start' });

export const CommentSchema = z
  .object({
    block_id: z.string(),
    content: z.string(),
    is_resolved: z.boolean().optional(),
    thread_id: z.string().optional(),
    user: userSchema,
    anchor: commentAnchorSchema.optional(),
    anchor_detached_at: z.string().optional(),
  })
  .strict();

export const DbCommentSchema = CommentSchema.merge(baseDatabaseSchema);

export type CommentAnchor = z.infer<typeof commentAnchorSchema>;
export type DbComment = z.infer<typeof DbCommentSchema> & PK;
